import ReactDOM from "react-dom";
import App from "./routes/App";

import "./i18n/i18n";

import "./assets/scss/index.scss";

ReactDOM.render(<App />, document.getElementById("root"));
